/**
 * @title deliverymethodinfomodal.js: Sub-module for Global pages
 * @description This module is used to display the deliverymethodinfomodal modal
 * @dependency 
 */
define(['dialog'], function(dialog) {	
	
	var deliverymethodinfomodal = {
			
		init : function() {
			this.attachExternalClass();
		},	 
    
	    attachExternalClass : function(){
			$('.modal-delivery-and-pickup-text').unbind().on('click', this.bind_external);
		},
	
	   	bind_external : function(event) {
	   		let callerElement = event.target;
	   		COSTCO.dialog.returnFocusOnCallerElement(callerElement);
	   		deliverymethodinfomodal.createDialogBox(this.href);
	   		event.preventDefault();
	   	},
	    
	    createDialogBox : function(url) {
	    	dialog.createExtDialogBox({
	    		title : messages.DELIVERY_METHOD_INFO,
	    		body : COSTCO.util.tmpl('tmpl_deliverymethodinfo_modal',{})
	    	});
	    }
		
	}
	
    if (typeof window.COSTCO === "undefined") {
        window.COSTCO = new Object();
    } 
	
    window.COSTCO.deliverymethodinfomodal = deliverymethodinfomodal;
		
	return deliverymethodinfomodal;
    
});


// WEBPACK FOOTER //
// ./js/utility/deliverymethodinfomodal.js